import React, { useEffect, useRef, useState } from 'react';
import '../styles/Hero.css';
import { FaRocket, FaRobot, FaBrain, FaChartLine, FaShieldAlt, FaUserAstronaut } from 'react-icons/fa';

const Hero = () => {
  const titleRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    console.log('Hero mounted');
    setIsVisible(true);

    // Debug logs for dimensions
    const logDimensions = () => {
      if (heroRef.current && contentRef.current) {
        const heroRect = heroRef.current.getBoundingClientRect();
        const contentRect = contentRef.current.getBoundingClientRect();
        
        console.log('Hero dimensions:', {
          width: heroRect.width,
          height: heroRect.height,
          top: heroRect.top,
          left: heroRect.left
        });
        
        console.log('Content dimensions:', {
          width: contentRect.width,
          height: contentRect.height,
          top: contentRect.top,
          left: contentRect.left
        });
      }
    };

    logDimensions();
    window.addEventListener('resize', logDimensions);
    return () => window.removeEventListener('resize', logDimensions);
  }, []);

  return (
    <div ref={heroRef} className="hero debug-border">
      <div ref={contentRef} className={`hero-content debug-border ${isVisible ? 'visible' : ''}`}>
        <div className="hero-badge-container debug-border">
          <div className="hero-badge">
            <FaRobot className="badge-icon" />
            <span>AI-POWERED CRYPTO AGENT</span>
          </div>
        </div>

        <div className="glitch-container debug-border">
          <h1 ref={titleRef} className="glitch">THE FIRM</h1>
          <div className="subtitle-container">
            <p className="subtitle">PROTOCOLS</p>
            <div className="subtitle-line"></div>
          </div>
        </div>

        <p className="hero-description debug-border">
          Revolutionizing crypto trading with advanced AI technology.
          <span className="description-highlight"> Experience the future of automated trading.</span>
        </p>

        <div className="feature-grid debug-border">
          <div className="feature-item">
            <FaRocket className="feature-icon" />
            <h3>Fast Execution</h3>
            <p>Lightning-fast trade execution with minimal slippage</p>
          </div>
          <div className="feature-item">
            <FaBrain className="feature-icon" />
            <h3>AI Analysis</h3>
            <p>Real-time market analysis powered by advanced AI</p>
          </div>
          <div className="feature-item">
            <FaChartLine className="feature-icon" />
            <h3>Smart Trading</h3>
            <p>Intelligent trading strategies optimized for profit</p>
          </div>
          <div className="feature-item">
            <FaShieldAlt className="feature-icon" />
            <h3>Secure System</h3>
            <p>Enterprise-grade security for your peace of mind</p>
          </div>
        </div>

        <div className="hero-buttons debug-border">
          <a href="/documentation" className="btn primary-btn">
            <span className="btn-content">
              <FaUserAstronaut className="btn-icon" />
              <span className="btn-text">Get Started</span>
            </span>
          </a>
          <a href="https://t.me/TheFirmAIProtocols_bot" target="_blank" rel="noopener noreferrer" className="btn secondary-btn">
            <span className="btn-content">
              <FaRobot className="btn-icon" />
              <span className="btn-text">Try AI Agent</span>
            </span>
          </a>
        </div>

        <div className="hero-stats debug-border">
          <div className="stat-item">
            <span className="stat-value">24/7</span>
            <span className="stat-label">Active Trading</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">100%</span>
            <span className="stat-label">AI Powered</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">0.1s</span>
            <span className="stat-label">Response Time</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;